const _menuBtn = $('#js-hamburger')
const _header = $('#js-header')
const _navigation = $('#js-navigation')
_menuBtn.click(function(){
	$('html').toggleClass('is-fixed')
	$(this).toggleClass('is-active')
	$(_navigation).toggleClass('is-open')
})
